<template>
  <ul class="faq_list">
    <li v-for="item in contactData">
      <Category :category="item.searchWords" :label="item.displayText" :iconPath="item.iconFilePath"/>
    </li>
  </ul>
</template>

<script>
import Category from "@/components/Category.vue";

export default {
  name: "FaqList",
  components: {
    Category,
  },
  props: [
    'contactData',
  ],
};
</script>

<style scoped>
.faq_list {
  margin-top: 10px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.faq_list li {
    width: 32%;
    padding: 10px 0;
    -ms-flex: 0 1 auto;
    white-space: pre-line;
    margin: 0 6px;
}

.faq_list li a {
    color: #076cb9;
    font-size: 16px;
    font-weight: bold;
    width: 100%;
    border: 3px solid #076cb9;
    border-radius: 4px;
    display: flex;
    padding: 0px;
    text-align: center;
    text-decoration: none;
    height: 140px;
    align-items: center;
    justify-content: center;
}

.faq_list li a:hover {
    color: #63b2ed;
    border: 3px solid #63b2ed;
    background: #fafdff;
}

@media screen and (max-width: 935px) {
  .faq_list li {
    width: 48%;
  }
}

@media screen and (max-width: 670px) {
    .page_title {
        font-size: 30px !important;
    }

    .sub_title {
        font-size: 24px;
        margin: 20px 0px 10px 0px;
    }

    .faq_list li {
        width: 100%;
        padding: 5px 0;
    }

    .faq_list li a {
        border: 2px solid #076cb9;
        border-radius: 4px;
        padding: 16px;
    }
}
</style>
